import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

export const deleteQuestions = createAsyncThunk(
  'deleteQuestions',
  async (params, { rejectWithValue }) => {
    try {
      const token = params?.token;
      const surveyId = params?.surveyId;
      const sectionId = params?.sectionId;
      const questionId = params?.queId;

      const urls = `${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_PREFIX_URL}${surveyId}/section/${sectionId}/question/${questionId}/`;

      const headers = { Authorization: `Bearer ${token}` };

      const response = await axios.delete(urls, { headers });
      // console.log('response>>>>', response);
      return response.data.message;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const deleteQuestionSlice = createSlice({
  name: 'deleteQuestion',
  initialState,
  reducers: {
    clearData(state) {
      state.data = [];
      state.error = '';
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(deleteQuestions.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteQuestions.fulfilled, (state, action) => {
      // console.log('delete data:', action.payload);
      state.loading = false;
      state.data = action.payload;
      state.error = '';
    });
    builder.addCase(deleteQuestions.rejected, (state, action) => {
      state.loading = false;
      state.data = [];
      state.error = action.error.message;
    });
  },
});
export const { clearData, setLoading } = deleteQuestionSlice.actions;
export default deleteQuestionSlice.reducer;
